import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SelectCustomEvent} from '@ionic/angular';
@Component({
    selector: 'app-select-type-movimento',
    templateUrl: './select-type-movimento.component.html',
    styleUrls: ['./select-type-movimento.component.scss'],
    standalone: false
})
export class SelectTypeMovimentoComponent  {
  @Input() movimentoType: number;
  @Output() movimentoTypeChange = new EventEmitter<number>();
  @Input() activeEmpty = false;
  public movimentoTypes =
    [
      {value: 1, label: 'Carico / Trasferimento'},
      { value: -1, label: 'Scarico' },
      {value: 0, label: 'Inventario / Rettifica'}
    ];
  selectMovimentoType = (e: SelectCustomEvent) => this.movimentoTypeChange.emit(+e.target.value);
}
